<template>
  <div class="code-container" id="code-container">
    <div
      class="code-mirror"
      :ref="refId"
      :style="layout.codeMirror"
    >
    </div>
    <div
      class="table-container"
      v-if="language === 'sql'"
      :style="layout.tableContainer"
    >
      <div class="res-table">
        <template
          v-if="output && output.result_arr && output.result_arr.length"
        >
          <j-tabs v-model="activeName" @tabChange="tabChange">
            <j-tab
              v-for="(item, index) in output.result_arr"
              :key="index"
              :index="index"
              :label="item.tab"
            >
              <table v-if="item.code === 200" class="table">
                <thead>
                  <tr>
                    <td v-for="key of theader(item.data)" :key="key">
                      {{ key }}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="language === 'sql'">
                    <tr v-for="(temp, index) in item.data" :key="index">
                      <td v-for="key of theader(item.data)" :key="key">
                        {{ temp[key] }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <div style="padding: 5px; color: #cf1322" v-else>
                {{ item.data }}
              </div>
            </j-tab>
          </j-tabs>
        </template>

        <template v-else>
          <table
            v-if="
              output &&
                output.code === 200 &&
                output.data &&
                ((Object.prototype.toString.call(output.data) ===
                  '[object Array]' &&
                  output.data.length) ||
                  Object.prototype.toString.call(output.data) ===
                    '[object Object]')
            "
            class="table"
          >
            <thead>
              <tr>
                <td
                  v-for="(key, index) of theader(output.data)"
                  :key="`td-header-${index}`"
                >
                  {{ key }}
                </td>
              </tr>
            </thead>
            <tbody>
              <template v-if="language === 'sql'">
                <tr v-for="(temp, index) in output.data" :key="`tr-${index}`">
                  <td
                    v-for="(key, index) of theader(output.data)"
                    :key="`td-${index}`"
                  >
                    {{ temp[key] }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <div
            style="padding: 5px; color: #cf1322"
            v-if="output && output.code !== 200"
          >
            {{ output.msg }}
          </div>
        </template>
      </div>
    </div>
    <div
      v-if="language !== 'sql'"
      class="text-container"
      :style="layout.textContainer"
    >
      <pre
        class="error-text"
        v-if="output && output.code !== 200"
        style="color: #cf1322"
        >{{ output.msg }}
      </pre>
      <pre
        class="python-text"
        v-else-if="output && output.code === 200 && hasImg"
        :style="theme === 'dark' ? 'color:#fff' : 'color:#333'"
        v-html="output.data.replace(/\$html{([\w\W]+?)}/gm, '$1')"
      ></pre>
      <pre v-else-if="output">{{ output.data }}</pre>
    </div>
  </div>
</template>
<script type="text/babel">
import * as monaco from "monaco-editor";
import JTabs from "../tabs/JTabs";
import JTab from "../tabs/JTab";
import { language as pythonLanguages } from 'monaco-editor/esm/vs/basic-languages/python/python.js';
import { language as sqlLanguages } from 'monaco-editor/esm/vs/basic-languages/sql/sql';
import { language as javaLanguages } from 'monaco-editor/esm/vs/basic-languages/java/java';
import { language as shellLanguages } from 'monaco-editor/esm/vs/basic-languages/shell/shell';
import { language as cppLanguages } from 'monaco-editor/esm/vs/basic-languages/cpp/cpp';

export default {
  name: "Code",
  props: {
    refId: {
      type: String,
      default: "onlineCode"
    },
    language: {
      type: String,
      default: ""
    },
    paramsLanguage: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: "dark"
    },
    isVertical: {
      type: Boolean,
      default: true
    },
    output: {
      type: Object,
      default: () => {}
    },
    inputCode: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否开启只读关键代码功能 默认不开启
    readOnlyCoreCode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeName: 0,
      codeEditor: null,
      readOnlyArray: [],
      listen: null,
      listenSize: null,
      registerLang: [],
      registerPrototype: [],
      onloadPosition: false
    };
  },
  computed: {
    theader() {
      return function(output) {
        let arr = [];
        if (output) {
          for (let key in output[0]) {
            arr.push(key);
          }
        }
        return arr;
      };
    },
    layout() {
      let codeMirror;
      let tableContainer;
      let textContainer;
      if (this.isVertical) {
        // 竖屏
        codeMirror = "height: 100%;width: 60%;";
        tableContainer = "height: 100%; width: 39%;";
        textContainer = "height: 100%;width: 39%;";
      } else {
        // 横屏
        codeMirror = "height: 70%; width: 100%;";
        tableContainer = "height: 28%;width: 100%;margin-top: 11px;";
        textContainer = "margin-top: 11px;height: 28%; width: 100%;";
      }
      if (this.theme === "light") {
        tableContainer += "background-color: #eee; color: #333;";
        textContainer += "background-color: #eee; color: #333;";
      } else {
        tableContainer += "color: #fff;";
        textContainer += "color: #fff;";
      }
      return {
        codeMirror: codeMirror,
        tableContainer: tableContainer,
        textContainer: textContainer
      };
    },
    hasImg() {
      // 兼容类型 print(type(123))
      if (this.output && this.output.code === 200) {
        const test = this.output.data.replace(/\$html{([\w\W]+?)}/gm, "$1");
        if (test.indexOf("<img") >= 0) {
          return true;
        }
      }
      return false;
    },
    code() {
      if (!this.codeEditor) return "";
      return this.codeEditor.getValue();
    }
  },
  watch: {
    language(val) {
      this.registerLanguageProvider(this.language);
      this.updateLanguage(val);
    },
    disabled(val) {
      this.updateReadOnly(val)
    },
    inputCode: {
      handler(val) {
        this.$nextTick(() => {
          if (!this.codeEditor) return;
          const position = this.codeEditor.getPosition();
          // 重新定位光标
          this.onloadPosition = true;
          this.codeEditor.setValue(val);
          this.codeEditor.setPosition(position);
          this.onloadPosition = false;
          this.handleReadOnly();
        })
      },
      immediate: true
    }
  },
  mounted() {
    this.codeEditor = monaco.editor.create(
      this.$refs[this.refId],
      {
        value: this.inputCode,
        language: this.language,
        theme: 'vs-dark',
        readOnly: this.disabledInput,
        tabSize: 2,
        wordWrap: "on",
        autoIndent: "full",
        automaticLayout: true,
        wrappingIndent: "same",
        renderWhitespace: "none",
        minimap: { enabled: false },
        scrollBeyondLastLine: false,
        fixedOverflowWidgets: true,
        multiCursorModifier: "ctrlCmd"
      }
    );
    this.registerLanguageProvider(this.language);
    this.formatDocument();
  },
  methods: {
    // readOnlyCoreCode 只读核心代码功能
    handleReadOnly() {
      this.$nextTick(() => {
        if (!this.readOnlyCoreCode) return;
        // 只读代码获取
        const readOnlyArr = this.getReadOnlyIndex(this.inputCode);
        readOnlyArr.forEach(item => {
        // 样式覆盖(只覆盖一次即可) 
        this.codeEditor.deltaDecorations([], [{
            range: new monaco.Range(item.startIndex, 0, item.endIndex, 0),
            options: {
              isWholeLine: true,
              className: 'online-code-readonly',
              inlineClassName: 'online-code-readonly'
            }
          }]);
        });
        if (readOnlyArr.length) {
          this.readOnlyArray = readOnlyArr;
          this.listenCursorPosition();
          // 监听高度变更，重新获取只读代码位置
          if (this.listenSize) return;
          this.listenSize = this.codeEditor.onDidContentSizeChange(e => {
            if (e.contentHeightChanged) {
              this.readOnlyArray = this.getReadOnlyIndex(this.code)
              this.listenCursorPosition();
            }
          })
        };
      })
    },
    tabChange(index) {
      this.activeName = index;
    },
    formatDocument(){
      this.codeEditor.getAction("editor.action.formatDocument").run();
      this.codeEditor.getModel().onDidChangeContent(() => {
        this.$emit('input', this.codeEditor.getValue())
      });
    },
    updateReadOnly(readOnly) {
      this.codeEditor.updateOptions({ readOnly });
    },
    updateLanguage(language) {
      monaco.editor.setModelLanguage(this.codeEditor.getModel(), language);
    },
    // 获取只读代码行数
    getReadOnlyIndex(content) {
      const arr = content.split("\n");
      const indexArr = [];
      let tempObj = null;
      arr.forEach((string, index) => {
        /** 兼容多种语言的注释
         * c++ //
         * java  //
         * node js //
         * python #
         * sql --
         */
        const stringFormat = string.replace(/\s+/g, "");
        const regStart = /^((\/\/|\#|\-\-)hide\-start)/;
        const regEnd = /((\/\/|\#|\-\-)hide\-end)/;
        if (stringFormat.match(regStart)) {
          tempObj = { startIndex: index + 1 };
        }
        if (stringFormat.match(regEnd)) {
          if (tempObj && typeof tempObj.startIndex === "number") {
            tempObj.endIndex = index + 1;
            indexArr.push(tempObj);
            tempObj = null;
          }
        }
      });
      return indexArr
    },
    // 监听光标，移动到只读区域，强行移动光标
    listenCursorPosition() {
      if (this.listen) return;
      this.listen = this.codeEditor.onDidChangeCursorPosition(e => {
        const cursor = this.moveCursor(e.position.lineNumber, this.readOnlyArray)
        if (e.position.lineNumber !== cursor && !this.onloadPosition) {
          // 获取当前编辑器最大行数
          const maxLine = this.codeEditor.getModel().getLineCount();
          // 某些操作会导致，最大行数小于要移动光标的行数
          if (maxLine < cursor) {
            this.codeEditor.trigger('keyboard', 'undo');
          }
          this.codeEditor.setPosition({
            lineNumber: cursor,
            column: 0
          });
        }
      })
    },
    // 强行移动光标
    moveCursor(e,arr) {
      let cursorIndex = e;
      for (let i = 0; i < arr.length; i++) {
        const { startIndex, endIndex } = arr[i];
        if ((startIndex) <= cursorIndex && cursorIndex <= (endIndex)) {
          cursorIndex = endIndex + 1;
          break;
        }
      }
      return cursorIndex;
    },
    // 重置代码
    handleResetCode() {
      this.codeEditor.setValue(this.inputCode);
      this.handleReadOnly();
    },
    // 代码自动补全注册
    registerLanguageProvider(lang) {
      // ['sql','javascript','java','cpp','python','shell'];
      // 记录已注册过的语言 JavaScript
      if (this.registerLang.includes(lang) || lang === 'javascript') {
        return;
      }
      this.registerLang.push(lang)
      const prototype = monaco.languages.registerCompletionItemProvider(lang, {
        provideCompletionItems: () => {
          let suggestions = [];
          if (lang === 'python') {
            pythonLanguages.keywords.forEach(item => {
              suggestions.push({
                label: item,
                kind: monaco.languages.CompletionItemKind.Keyword,
                insertText: item
              });
            })
          }
          if (lang === 'sql') {
            sqlLanguages.keywords.forEach(item => {
              suggestions.push({
                label: item,
                kind: monaco.languages.CompletionItemKind.Keyword,
                insertText: item
              });
            });
            sqlLanguages.operators.forEach(item => {
              suggestions.push({
                label: item,
                kind: monaco.languages.CompletionItemKind.Operator,
                insertText: item
              });
            });
            sqlLanguages.builtinFunctions.forEach(item => {
              suggestions.push({
                label: item,
                kind: monaco.languages.CompletionItemKind.Function,
                insertText: item
              });
            });
            sqlLanguages.builtinVariables.forEach(item => {
              suggestions.push({
                label: item,
                kind: monaco.languages.CompletionItemKind.Variable,
                insertText: item
              });
            })
          }
          if (lang === 'java') {
            javaLanguages.keywords.forEach(item => {
              suggestions.push({
                label: item,
                kind: monaco.languages.CompletionItemKind.Keyword,
                insertText: item
              });
            });
            javaLanguages.operators.forEach(item => {
              suggestions.push({
                label: item,
                kind: monaco.languages.CompletionItemKind.Operator,
                insertText: item
              });
            });
          }
          if (lang === 'cpp') {
            cppLanguages.keywords.forEach(item => {
              suggestions.push({
                label: item,
                kind: monaco.languages.CompletionItemKind.Keyword,
                insertText: item
              });
            });
            cppLanguages.operators.forEach(item => {
              suggestions.push({
                label: item,
                kind: monaco.languages.CompletionItemKind.Operator,
                insertText: item
              });
            });
          }
          if (lang === 'shell') {
            shellLanguages.keywords.forEach(item => {
              suggestions.push({
                label: item,
                kind: monaco.languages.CompletionItemKind.Keyword,
                insertText: item
              });
            });
            shellLanguages.builtins.forEach(item => {
              suggestions.push({
                label: item,
                kind: monaco.languages.CompletionItemKind.Constant,
                insertText: item
              });
            });
          }
          return { suggestions }
        }
      })
      this.registerPrototype.push(prototype)
    }
  },
  destroyed(){
    if (this.registerPrototype && this.registerPrototype.length) {
      for(let i = 0;i<this.registerPrototype.length;i++) {
        this.registerPrototype[i].dispose()
      }
    }
    this.codeEditor && this.codeEditor.dispose()
  },
  components: {
    JTabs,
    JTab
  }
};
</script>
<style lang="css" scoped>
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #d9d9d9;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(165, 157, 157, 0.2);
  border-radius: 0;
  background: #595959;
}
.code-container {
  overflow: auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.code-mirror {
  overflow: auto;
}
.table-container {
  overflow: auto;
}
.down-load {
  width: 60px;
  margin: 0 auto;
  text-align: center;
  line-height: 25px;
  border: 1px solid #416d3d;
  border-top: none;
  border-radius: 3px;
  cursor: pointer;
}
.table {
  margin: 5px;
  text-align: center;
  border: 1px solid #5a5e5d;
  border-right: none;
  border-top: none;
}
td {
  border: 1px solid #5a5e5d;
  border-left: none;
  border-bottom: none;
  padding: 5px;
}
.el-tabs__content {
  overflow: visible;
  font-size: 14px;
}
.text-container >>> .el-tabs__item {
  color: #8c8c8c;
  border: none;
  line-height: 30px;
  height: 30px;
}
.text-container >>> .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}
.text-container >>> .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-left: none;
}
.text-container >>> .el-tabs__item.is-active {
  border: none;
  border-bottom: 2px solid #0fc700;
  color: #0fc700;
}
.text-container >>> .el-tabs__header {
  border: none;
  margin-bottom: 5px;
}
.text-container >>> .el-tabs__nav {
  border: none;
}
.text-container >>> .res-table {
  height: 100%;
  width: 100%;
  overflow: auto;
}
.text-container {
  overflow: auto;
}
.python-text {
  margin: 5px;
}
.python-text >>> img {
  width: 400px;
  /* height: 200px; */
}

.code-mirror >>> .online-code-readonly {
  color: rgba(255, 255, 255, 0.25);
  cursor: not-allowed;
  position: relative;
  background: repeating-linear-gradient(-45deg, #333333, #333333 4px, #3F3F3F, #3F3F3F 6px);
}
.code-mirror >>> .online-code-readonly:hover::after {
  content: "初始代码，请勿修改";
  position: absolute;
  top: -16px;
  left: 0;
  background-color: #000;
  color: #fff;
  padding: 1px 4px;
  border-radius: 5px;
  display: block;
}
</style>
